import { Argv } from 'yargs'

export const handler = (): null => null
export const command = 'circleci <command>'
export const description = 'execute commands related to circleci'
export const builder = (yargs: Argv): Argv => yargs.commandDir('circleci-commands')
